module.exports = new __parcel__URL__("OKR Tracking Hover.1ed55ab5.svg").toString();